import React from 'react';

import { Select } from '@aline/common';
import { IconButton } from '@mui/material';
import { AlineTooltip } from 'src/components';
import { BulletedListIcon } from 'src/components/icons/BulletedListIcon';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => ({
  outlineToggle: {
    '&:hover': {
      backgroundColor: 'white',
    },
    alignItems: 'center',
    backgroundColor: 'white',
    border: `1px solid #D1D1D1`,
    borderRadius: '50%',
    boxShadow: '0px 2px 4px 0px #324A523D',
    cursor: 'pointer',
    display: 'flex',
    height: '44px',
    justifyContent: 'center',
    marginLeft: '6px',
    width: '44px',
    zIndex: theme.zIndex.tooltip,
  },
}));

export function OutlineToggle({ handleOpen }: { handleOpen: () => void }) {
  const { classes } = useStyles();
  return (
    <AlineTooltip arrow placement="right" title="Show outline">
      <IconButton
        aria-label="Show outline"
        className={classes.outlineToggle}
        data-cy={Select.document.leftOutline.openOutlineButton}
        onClick={handleOpen}
      >
        <BulletedListIcon fill="#324A52" style={{ height: 22, width: 22 }} />
      </IconButton>
    </AlineTooltip>
  );
}
